import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { fetchRemoteVisits, mapSiteVisits } from '../lib/remote';
import type { Site, Visit } from '../lib/types';

export function useSiteVisits(site: Site | null, intervalMs = 8000): Visit[] {
  const { user } = useAuth();
  const [visits, setVisits] = useState<Visit[]>([]);

  useEffect(() => {
    if (!site || !user?.apiToken) {
      setVisits([]);
      return;
    }
    let cancelled = false;
    const load = async () => {
      const remote = mapSiteVisits(site, await fetchRemoteVisits(site.trackingCode, user.apiToken));
      if (!cancelled) setVisits(remote);
    };
    load();
    const timer = window.setInterval(load, intervalMs);
    return () => {
      cancelled = true;
      window.clearInterval(timer);
    };
  }, [site, user?.apiToken, intervalMs]);

  return visits;
}
